var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 23.175L6.2 24.9375L8.45 22.7L6.675 20.925L4.4375 23.175ZM13.75 28.0625C14.15 28.0625 16.25 28.0625 16.25 28.0625V24.375H13.75V28.0625ZM15 6.875C13.0109 6.875 11.1032 7.66518 9.6967 9.0717C8.29018 10.4782 7.5 12.3859 7.5 14.375C7.5 16.3641 8.29018 18.2718 9.6967 19.6783C11.1032 21.0848 13.0109 21.875 15 21.875C16.9891 21.875 18.8968 21.0848 20.3033 19.6783C21.7098 18.2718 22.5 16.3641 22.5 14.375C22.5 10.225 19.1375 6.875 15 6.875ZM25 15.625H28.75V13.125H25V15.625ZM21.55 22.7L23.8 24.9375L25.5625 23.175L23.325 20.925L21.55 22.7ZM25.5625 5.575L23.8 3.8125L21.55 6.05L23.325 7.825L25.5625 5.575ZM16.25 0.6875H13.75V4.375H16.25V0.6875ZM5 13.125H1.25V15.625H5V13.125ZM8.45 6.05L6.2 3.8125L4.4375 5.575L6.675 7.825L8.45 6.05Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSun);
export default __webpack_public_path__ + "static/media/icon-sun.1f7484e521d4c8828362139deeb42ccb.svg";
export { ForwardRef as ReactComponent };